module.exports = __webpack_public_path__ + "files/96ceb2566a03d3b07f2f0ddfc7c44258.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-10.png
// module id = 1499
// module chunks = 60